import React from 'react';
import { Link } from 'react-router-dom';
import { PawPrint, Heart, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { WHY_STARTED } from '../data/mock';

const WhyWeStarted = () => {
  return (
    <section className="py-20 lg:py-24 bg-gradient-to-b from-[#fdf3fc] via-white to-[#fdf3fc] relative overflow-hidden">
      <PawPrint className="absolute top-10 left-10 w-24 h-24 text-[#f3d6f5]/40 rotate-12" />
      <PawPrint className="absolute bottom-10 right-10 w-32 h-32 text-[#f3d6f5]/40 -rotate-12" />

      <div className="relative max-w-[1280px] mx-auto px-5 lg:px-10 grid lg:grid-cols-[1.1fr_1fr] gap-12 lg:gap-16 items-center">
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center gap-2 text-[#e870b6] font-semibold tracking-[0.2em] text-[13px] uppercase mb-4">
            <Heart size={16} className="fill-[#e870b6]" /> {WHY_STARTED.tag}
          </span>
          <h2 className="font-serif text-[36px] lg:text-[48px] font-extrabold text-[#1a0b3d] leading-[1.1] mb-6">
            {WHY_STARTED.title}
          </h2>
          {WHY_STARTED.paragraphs.map((p, i) => (
            <p key={i} className="text-slate-600 leading-relaxed mb-5 text-[16px] lg:text-[17px]">
              {p}
            </p>
          ))}
          <Link to="/about" className="inline-flex items-center gap-2 mt-3">
            <Button className="rounded-full bg-[#5b3eb5] hover:bg-[#4a31a3] text-white px-7 py-6 h-auto gap-2 shadow-md hover:shadow-xl transition-all">
              Read Our Full Story <ArrowRight size={16} />
            </Button>
          </Link>
        </div>

        <div className="order-1 lg:order-2 relative">
          <div className="rounded-[28px] overflow-hidden shadow-2xl aspect-[4/5] bg-gradient-to-br from-[#ffd6e7] to-[#f3d6f5]">
            <img
              src={WHY_STARTED.image}
              alt="Ichi and Ori — born from love"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-white rounded-2xl shadow-xl p-5 max-w-[240px] border border-[#f3d6f5]">
            <div className="flex items-center gap-2 mb-2">
              <Heart className="w-4 h-4 text-[#e870b6] fill-[#e870b6]" />
              <span className="text-[12px] uppercase tracking-[0.2em] text-slate-500 font-semibold">A tribute to</span>
            </div>
            <p className="font-serif text-[18px] text-[#1a0b3d] leading-snug font-bold">
              Ichi, Ori, Zazu &amp; a father who loved all animals.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyWeStarted;
